import { FieldValues, UseFieldArrayAppend, UseFieldArrayInsert, UseFieldArrayRemove } from 'react-hook-form';

import { VOLUME_IN_OPTION_VALUES } from 'constants/businessTool';

export const PRODUCT_NAMES = {
  PRODUCT_ID: 'productId',
  NAME: 'name',
  PRICE: 'price',
  VOLUME_UNITS: 'volumeUnits',
  MONTHLY_SALES_PLAN_PHYSICAL: 'monthlySalesPlanPhysical',
  MONTHLY_SALES_PLAN_MONETARY: 'monthlySalesPlanMonetary',
  ANNUAL_PRICE_GROWTH_RATE: 'annualPriceGrowthRate',
  ANNUAL_SALES_GROWTH_RATE: 'annualSalesGrowthRate',
  ANNUAL_EXPENSE_GROWTH: 'annualExpenseGrowth',
  COST_PER_UNIT: 'costPerUnit',
} as const;

export interface IGlobalProductEntity {
  [PRODUCT_NAMES.PRODUCT_ID]?: string;
  [PRODUCT_NAMES.NAME]?: string;
  [PRODUCT_NAMES.PRICE]?: string;
  [PRODUCT_NAMES.VOLUME_UNITS]?: string;
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL]?: string;
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY]?: string;
  [PRODUCT_NAMES.ANNUAL_PRICE_GROWTH_RATE]?: string;
  [PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE]?: string;
  [PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH]?: string;
  [PRODUCT_NAMES.COST_PER_UNIT]?: string;
}

export interface IUseFieldArrayProduct extends IGlobalProductEntity {
  id: string;
}

export interface IUseFieldArrayReturnValue {
  fields: IUseFieldArrayProduct[];
  append: UseFieldArrayAppend<FieldValues, string>;
  remove: UseFieldArrayRemove;
  insert: UseFieldArrayInsert<FieldValues>;
}

export const productInitialValues: IGlobalProductEntity = {
  [PRODUCT_NAMES.PRODUCT_ID]: '',
  [PRODUCT_NAMES.NAME]: '',
  [PRODUCT_NAMES.PRICE]: '',
  [PRODUCT_NAMES.VOLUME_UNITS]: VOLUME_IN_OPTION_VALUES.PIECES.value,
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL]: '',
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY]: '',
  [PRODUCT_NAMES.ANNUAL_PRICE_GROWTH_RATE]: '',
  [PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE]: '',
  [PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH]: '',
  [PRODUCT_NAMES.COST_PER_UNIT]: '',
};
